import {
  afterNextRender,
  AfterViewInit,
  Component,
  DestroyRef,
  inject,
  Inject,
  PLATFORM_ID,
  signal
} from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AnalyticsService } from '@services/analytic.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements AfterViewInit {
  protected readonly title = signal('binixo-landing');
  analytics = inject(AnalyticsService);
  router = inject(Router);
  destroyRef = inject(DestroyRef);

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    afterNextRender(() => {
      this.analytics.initAll();

      this.router.events
        .pipe(
          filter((e) => e instanceof NavigationEnd),
          takeUntilDestroyed(this.destroyRef),
        )
        .subscribe(() => this.analytics.trackPageView());
    });
  }


  ngAfterViewInit() {
    // TODO eSputnik
    // if (isPlatformBrowser(this.platformId) && window['navigator']?.serviceWorker) {
    //   // реєстрація service worker
    //   navigator.serviceWorker.register('/sw.js');
    //
    //   // ініціалізація eSputnik push
    //   if (window['es']) {
    //     console.log(window['es']);
    //     window['es']('pushOn');
    //   }
    // }
  }
}
